import { render, staticRenderFns } from "./Vans.vue?vue&type=template&id=08129a0b&scoped=true&"
import script from "./Vans.vue?vue&type=script&lang=ts&"
export * from "./Vans.vue?vue&type=script&lang=ts&"
import style0 from "./Vans.vue?vue&type=style&index=0&id=08129a0b&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08129a0b",
  null
  
)

export default component.exports